import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Modal from '../common/Modal';
const Player = styled.div`
  display: flex; flex-direction: column; gap: 16px; min-width: 0;
  p { font-size: 13px; overflow-wrap: anywhere; }
  audio { width: 100%; height: 40px; color-scheme: ${({ theme }) => theme.name}; }
  small { font-size: 12px; color: ${({ theme }) => theme.color.text_color_300}; }
`;
export default function AudioPlayerModal({ url, name, onClose }: { url: string; name: string; onClose: () => void }) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
    const audio = audioRef.current;
    return () => { audio?.pause(); };
  }, [url]);
  return <Modal title="음원 재생" onClose={onClose} width={450}>
    <Player><p>{name}</p><audio ref={audioRef} aria-label="음원 재생바" src={url} controls autoPlay preload="metadata" onError={() => setFailed(true)} />
      {failed ? <p role="alert">음원을 재생할 수 없습니다. 파일을 확인한 뒤 다시 열어주세요.</p> : <small>재생 버튼으로 음원을 듣고 재생 위치를 조절할 수 있습니다.</small>}
    </Player>
  </Modal>;
}
